import React, { useContext, useRef } from "react";
import {
  SpreadsheetContext,
} from "@gistapps/composite-spreadsheet";
import type {
  DataEditorProps,
} from "@gistapps/composite-spreadsheet";

const PhoneCellEditor = ({
  cell,
  column,
  row,
}: DataEditorProps) => {

  const {
    updateSpreadsheetCellData,
  } = useContext(SpreadsheetContext);

  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateSpreadsheetCellData(row, column, { value: e.target.value }, true);
  };

  return (
    <input
      ref={inputRef}
      type="tel"
      className="gc__table-phone-input"
      defaultValue={(cell?.value as string) ?? ""}
      onChange={handleChange}
      autoFocus
    />
  );

};

export default PhoneCellEditor;
